import { render, staticRenderFns } from "./LanguagesList.vue?vue&type=template&id=df0a7ed6&"
import script from "./LanguagesList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LanguagesList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df0a7ed6')) {
      api.createRecord('df0a7ed6', component.options)
    } else {
      api.reload('df0a7ed6', component.options)
    }
    module.hot.accept("./LanguagesList.vue?vue&type=template&id=df0a7ed6&", function () {
      api.rerender('df0a7ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/LanguagesList.vue"
export default component.exports